import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup } from "@angular/forms";
import { Subscription, BehaviorSubject } from "rxjs";
import { AuthService } from "../../../services/auth.service";
import { NoteType } from "../../../common/models/note-type.enum";
import { PaymentRecordAdjustmentNote } from "../../models/paymentItem.model";

@Component({
    selector: 'adjustment-request-notes',
    templateUrl: './adjustment-request-notes.component.html',
    styleUrls: ['./adjustment-request-notes.component.scss', '../../../common/components/notes/notes.component.scss'],
    standalone: false
})
export class AdjustmentRequestNotesComponent implements OnInit, OnDestroy {


    @Input() adjustmentId: string;

    form: FormGroup;

    private _notes: PaymentRecordAdjustmentNote[];    


    get disableSave(): boolean {
        if (this.form == null) return false;
        const contentCtrl = this.form.get("content");
        if (contentCtrl == null) return false;
        return contentCtrl.invalid || this.savingNote.value;
    }
    @Input() enabled: boolean = true;
    @Output() errorOccurred: EventEmitter<any> = new EventEmitter<any>();
    @Input() label: string = "Notes";

    get notes(): PaymentRecordAdjustmentNote[] {
        return this._notes;
    }

    @Input() set notes(data: PaymentRecordAdjustmentNote[]) {
        data = data.sort((a, b) => {
            if (a.createdDate < b.createdDate) return -1;
            if (b.createdDate < a.createdDate) return 1;
            return 0;
        });
        this._notes = data;
    }

    @Output() noteAdded: EventEmitter<PaymentRecordAdjustmentNote> = new EventEmitter<PaymentRecordAdjustmentNote>();
    @Output() noteDeleted: EventEmitter<number> = new EventEmitter<number>();

    noteType = NoteType;

    pendingNote: PaymentRecordAdjustmentNote;


    savingNote: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    subscription: Subscription = new Subscription;

    constructor(private auth: AuthService) { }

    ngOnInit() {

    }

    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }


    addNote(): void {
        this.pendingNote = {
            requestId: "",
            createdByName: this.auth.User.displayName,
            createdById: this.auth.User.id,
            adjustmentId: this.adjustmentId,
            text: "",
            createdDate: new Date((new Date).toISOString()),
            type: NoteType.Internal
        } as PaymentRecordAdjustmentNote;
    }

    cancel(): void {
        this.pendingNote = null;
    }

    deleteNote(index: number): void {
        this.noteDeleted.emit(index);
    }

    editorFormBuilt(group: FormGroup): void {
        this.form = group;
    }

    getNoteDate(note: PaymentRecordAdjustmentNote): string {
        const date = new Date(note.createdDate);
        return date.toLocaleDateString();
    }

    showDelete(noteCreator: string): boolean {
        if (this.enabled == false) return false;
        return noteCreator == this.auth.User.id;
    }

    submitNote(): void {
        this.pendingNote.createdDate = new Date((new Date).toISOString());
        this.pendingNote.text = this.form.get("content").value;
        this.noteAdded.emit(this.pendingNote);
        this.pendingNote = null;
    }

    throwError(err: any): void {
        this.errorOccurred.emit(err);
    }
}
